import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { z } from 'zod';

import type { ApiFailureError } from '../../../lib/http/errors';
import { useApiClient } from '../../session/client';
import { DATA_QUERY_KEY } from '../api/queries';
import { sharedMediaSchema } from '../api/schemas';
import { GET_ROUTES, routePath } from '../../../lib/http/routes';

export { sharedMediaSchema };
export type SharedMedia = z.infer<typeof sharedMediaSchema>;
export type SharedMediaRow = SharedMedia['rows'][number];

export type SharedMediaOrder = 'recent' | 'reach';

export function useSharedMedia(
  campaignId: string,
  tenantId: string,
  postId: string,
  order: SharedMediaOrder,
): UseQueryResult<SharedMedia, ApiFailureError> {
  const client = useApiClient();
  return useQuery<SharedMedia, ApiFailureError>({
    queryKey: DATA_QUERY_KEY(campaignId, tenantId, 'posts', postId, 'shared-media', order),
    queryFn: () =>
      client.getParsed(
        routePath(
          GET_ROUTES.postSharedMedia,
          { campaignId, postId },
          { tenant_id: tenantId, order },
        ),
        GET_ROUTES.postSharedMedia.schema,
      ),
    enabled: campaignId !== '' && tenantId !== '' && postId !== '',
  });
}
